module.exports = "/assets/data/0b99642db02ec7f67c6fef89cc4ed451-HD6.data.json";